import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';

import logo from '../../../assets/images/integrations/maxmind.webp';

const MaxmindFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="MaxmindFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" alt={t('settings.integrations.maxmind.title')} />
                                { t('settings.integrations.maxmind.title') }
                            </CardTitle>

                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.maxmind.database_path")}</Label>
                                            <Col lg={10} >
                                                <Field
                                                    required
                                                    component="input"
                                                    className="form-control"
                                                    type="text"
                                                    name="integrations.maxmind.database_path"
                                                    id="maxmind_database_path"
                                                    autoComplete="off"
                                                    placeholder="/usr/lib/GeoIP/db/GeoIP2-Country.mmdb"
                                                />
                                                <small className="form-text text-muted">
                                                    {t('settings.integrations.maxmind.database_path_help')}
                                                </small>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default MaxmindFields;
